<script lang="ts" setup>
import { computed } from 'vue'
import RoomieTag from '@lahaus-roomie/roomie/src/components/RoomieTag/index.vue'

import type { Props } from './types'

const props = withDefaults(defineProps<Props>(), {
  showUnitsLink: false
})

const getPictures = computed(() => {
  return props.pictures?.map((picture: string) => picture) ?? []
})

const picturesSources = computed(() => getPictures.value.map((url: string) => {
  return [
    {
      mediaWidth: 640,
      src: `${url}?auto=compress,enhance,format`,
      imageWidth: 400
    },
    {
      mediaWidth: 1023,
      src: `${url}?auto=compress,enhance,format`,
      imageWidth: 800
    },
    {
      mediaWidth: 2500,
      src: `${url}?auto=compress,enhance,format`,
      imageWidth: 1080
    }
  ]
}))

const resolveShowPictures = computed(() => props.pictures?.length)

const { t } = useI18n()

</script>

<script lang="ts">
export default {
  name: 'TypologyCarrousel'
}
</script>

<template>
  <section class="border border-carbon-light-50 rounded-md relative px-16 py-16">
    <AppCarrousel
      v-if="resolveShowPictures"
      id="quotation-plan-typology-blueprints"
      class="rounded-8 h-full w-full"
      :class="'aspect-square'"
      anchor-styles="w-full"
      img-styles="rounded-8"
      :image-multiplier="2"
      :pictures-sources
      zoom
      size-reverse />

    <RoomieTag
      v-if="typologyName"
      :id="`typology-carrousel-${typologyName}-tag`"
      class="absolute top-[16px] left-[16px]"
      variant="success"
      :label="t('type', { name: typologyName })" />
  </section>
</template>

<i18n src="./i18n.json" lang="json" />
